// src/components/Dashboard/ActivityFeed.jsx
import React from 'react';

export default function ActivityFeed({ activities }) {
  const data = activities || [];

  const getActivityIcon = (type) => {
    switch(type) {
      case 'sale': return '💰';
      case 'expense': return '💸';
      case 'customer': return '👤';
      default: return '📝';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold">Recent Activity</h3>
      </div>
      <div className="divide-y divide-gray-200">
        {data.length === 0 ? (
          <div className="p-6 text-center text-gray-500">No recent activity</div>
        ) : (
          data.map((activity, index) => (
            <div key={index} className="p-4 flex items-center space-x-3">
              <div className="text-2xl">{getActivityIcon(activity.type)}</div>
              <div className="flex-1">
                <p className="text-sm">{activity.description}</p>
                <p className="text-xs text-gray-500">{new Date(activity.created_at).toLocaleString()}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}